import React from 'react';
import { Form, Segment } from 'semantic-ui-react';
import { EventDropdown } from '../';


const TableHeader = (props) => {
  const { onSelectEvent, onAddCompetition } = props;

  return (
    <Segment basic>
      <Form>
        <Form.Group>
          <EventDropdown onSubmit={onSelectEvent}/>
          <Form.Button
            content='Add new competition/workshop'
            onClick={onAddCompetition}/>
        </Form.Group>
      </Form>
    </Segment>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competitions/Header.js